import LMSCourseCard from '@/components/LMSCourseCard';
import Constants from '@/Constants';
import { analyticsService, LMSEvents } from '@/services/AnalyticsService';
import { ApplicationState } from '@/store';
import { CourseStudentView } from '@/store/list/types';
import React from 'react';
import MagicSliderDots from 'react-magic-slider-dots';
import { useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import Slider from 'react-slick';
import _ from 'underscore';
import './style.scss';

const getCarouselDots = (dots: boolean) => {
    return <MagicSliderDots dotWidth={30} dots={dots} numDotsToShow={4} />;
};

const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    appendDots: (dots: boolean) => {
        return getCarouselDots(dots);
    },
};

const logEvent = (entityId: number | undefined, entityName: string) => {
    analyticsService.logEvent(LMSEvents.ACCESS_COURSE_SECTION_TRAINING, {
        entityId,
        entityName,
        moduleId: Constants.LMS_MODULE_ID,
        entityType: Constants.entityTypes.COURSE,
    });
};

interface Props {
    data: CourseStudentView[];
}

const WorkshopSection: React.FC<Props> = ({ data }: Props) => {
    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));

    const history = useHistory();

    return (
        <>
            {data.length > 0 && (
                <div className="workshop-section">
                    <div className="carousel-title-container">
                        <h2>{strings.WORKSHOPS}</h2>
                    </div>
                    <div className="carousel-slide-container">
                        <Slider {...settings}>
                            {data.map((courseStudentView) => (
                                <div key={_.uniqueId('courseCard_')}>
                                    <Link
                                        className="link-to-course"
                                        onClick={() => logEvent(courseStudentView.course.id, courseStudentView.course.name)}
                                        to={{
                                            pathname: `/lms/enrollments/${courseStudentView.classEnrollment.id}/courses/${courseStudentView.course.id}`,
                                            state: { goBackPath: history.location.pathname },
                                        }}
                                    >
                                        <LMSCourseCard
                                            course={courseStudentView.course}
                                            courseEnrollment={courseStudentView.courseEnrollment}
                                            mode={'view'}
                                            programClass={courseStudentView.programClass}
                                        />
                                    </Link>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            )}
        </>
    );
};

export default WorkshopSection;
